// This function is passed to the react-tooltip library and used
// as its overridePosition function, to put the tooltip in the right place.
export function getTooltipPosition(position, currentEvent, currentTarget, tooltip) {
  const doc = document.documentElement
  let left = Math.min(doc.clientWidth - tooltip.clientWidth, position.left)
  let top = Math.min(doc.clientHeight - tooltip.clientHeight, position.top)
  left = Math.max(0, left)
  top = Math.max(0, top)
  return { top, left }
}

export default { getTooltipPosition }
